import moment from 'moment';

export const formatDate = date => {
    return `${date.getFullYear()}-${date.getMonth()+1}-${date.getDate()}`
}

export const formatTime = (time, format = "HH:mm") => moment(time, format).format(format);